export class PartsTypeModel {
  id: number;
  name: string;
  description: string;
  isActive: boolean;
}
